// extracted by mini-css-extract-plugin
export var anchor = "_31-0";
export var discard = "_31-4";
export var muiTooltipTooltip = "_31-6";
export var notificationBar = "_31-3";
export var saveButtonHoverSlotWrapper = "_31-5";
export var show = "_31-2";
export var spacer = "_31-1";